import request from '@/utils/request'

export function fetch(query) {
  return request({
    url: 'categories',
    method: 'get',
    params: query
  })
}

export function fetchTree() {
  return request({
    url: 'categories/tree',
    method: 'get',
  })
}
